module.exports = __webpack_public_path__ + "img/treviso-belluno.c9f97c66.png";